import { DateTime } from 'luxon'

import { ActivityItem as ActivityItemBase, Text } from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import useActivity from '@hooks/useActivity'

import { ActivityModel } from '@models/types'

import { renderActionText } from '@functions/activity'

const renderTrackable = (trackable: ActivityModel['trackable']) => {
  if (trackable){
    return (
      <Text as="span" color="bodyFontLightColor" marginRight="small" style={{ textTransform: 'none' }}>
        for {trackable.type} #{trackable.id}
      </Text>
    )
  }

  return undefined
}

const renderActivityTitle = (parameters: ActivityModel['parameters']) => {
  if (parameters && parameters.title){
    return (
      <Text as="span" fontStyle="italic">
        - {parameters.title}
      </Text>
    )
  }

  return undefined
}

interface ActivityItemProps {
  activity: ActivityModel,
  boxProps?: object,
  isLastActivity: boolean,
}

const ActivityItem = (props: ActivityItemProps) => {
  const {
    activity,
    activity: {
      parameters, trackable,
    },
    boxProps,
    isLastActivity,
  } = props

  const {
    callbacks: { manageActivity },
    isDestructive,
  } = useActivity(activity)

  const createdDateString = digObject(activity, 'dates.created.date_time')

  return (
    <ActivityItemBase
      actionText={renderActionText(activity)}
      actionType={isDestructive ? 'destructive' : 'default'}
      boxProps={{
        paddingTop: 'medium',
        paddingBottom: isLastActivity ? 0 : 'medium',
        ...boxProps,
      }}
      dateTimeText={
        createdDateString
          ? DateTime.fromFormat(createdDateString, 'dd/MM/yyyy HH:mm').toFormat("ccc, dd LLL yyyy 'at' h:mm a")
          : 'Not Set'
      }
      description={(
        <>
          {renderTrackable(trackable)}
          {renderActivityTitle(parameters)}
        </>
      )}
      imageUrl={digObject(activity, 'owner.image.square_url')}
      onClick={() => manageActivity()}
      roleName={digObject(activity, 'owner.role')}
      title={digObject(activity, 'owner.title')}
    />
  )
}

export default ActivityItem
